import { AutomationBenefit } from "../app/automations/components/icon-automation-benefit";

export const benefitLabels: Record<AutomationBenefit, string> = {
  compliance: "Improves compliance",
  cycleTime: "Improves cycle time",
  failureRate: "Improves failure rate",
  security: "Improves security",
  techDebt: "Improves tech debt",
};
